import { ROUTE_QUIZLET, ROUTE_QUIZLET_QUESTIONNAIRE, ROUTE_QUIZLET_RESULTS } from '@/constants/routes';
import { RouteObject } from 'react-router-dom';
import QuizletSellPage from './quizlet-sell.page';
import { Navigate } from 'react-router-dom';
import { QuizletPage } from './quizlet.page';

export const routeQuizlet: RouteObject = {
  path: ROUTE_QUIZLET,
  element: <Navigate to={ROUTE_QUIZLET_QUESTIONNAIRE} replace />,
};

export const routeQuizletQuestionnaire: RouteObject = {
  path: ROUTE_QUIZLET_QUESTIONNAIRE,
  Component: QuizletPage,
};

export const routeQuizletResults: RouteObject = {
  path: ROUTE_QUIZLET_RESULTS,
  Component: QuizletSellPage,
};
